export function ErrorForm({ message }) {
  return message.length ? (
    <div className="bg-red-lightest text-red px-3 py-2 text-sm">{message}</div>
  ) : (
    ""
  );
}
